import {ChipList} from '@ui/forms/input-field/chip-field/chip-list';
import {Chip} from '@ui/forms/input-field/chip-field/chip';
import {Trans} from '@ui/i18n/trans';
import React from 'react';
import {HostAcc} from '@app/titles/models/HostAcc';

export function EnumDebridors(acc: HostAcc) {
  let hoster = '';
  if (acc.id_host && acc.id_host > 0) {
    if (acc.id_host === 2) {
      hoster = 'darkibox';
    } else if (acc.id_host === 5) {
      hoster = '1fichier.com';
    } else if (acc.id_host === 36) {
      hoster = 'send.cm';
    } else if (acc.id_host === 37) {
      hoster = 'media.cm';
    }
  }
  if (acc.provider) {
    if (acc.provider === 1) {
      hoster = 'debrid-link.com';
    } else if (acc.provider === 2) {
      hoster = 'alldebrid.com';
    } else if (acc.provider === 3) {
      hoster = 'real-debrid.com';
    }
  }
  return (
    <ChipList radius="rounded" color={'chip'} size="xs">
      <Chip key={hoster} selectable>
        <Trans message={hoster} />
      </Chip>
    </ChipList>
  );
}
